"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ResultTable_1 = require("@/pages/common/components/ResultTable");
var ResultTableSort_1 = require("@/pages/common/states/ResultTableSort");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var resultTableSortable = function (props) {
    var _a = React.useState(ResultTableSort_1.AvailableSortColumn.QUALITY_SCORE), currentSortColumn = _a[0], setCurrentSortColumn = _a[1];
    var _b = React.useState(ResultTableSort_1.AvailableSortOrder.DESC), currentSortOrder = _b[0], setCurrentSortOrder = _b[1];
    var _c = React.useState(props.properties), properties = _c[0], setProperties = _c[1];
    var onSortClick = function (column) {
        setCurrentSortOrder(currentSortOrder === ResultTableSort_1.AvailableSortOrder.DESC ? ResultTableSort_1.AvailableSortOrder.ASC : ResultTableSort_1.AvailableSortOrder.DESC);
        setCurrentSortColumn(column);
    };
    React.useEffect(function () {
        var compareFn = function (a, b) { return 0; };
        var negate = currentSortOrder === ResultTableSort_1.AvailableSortOrder.ASC ? -1 : 1;
        if (currentSortColumn === ResultTableSort_1.AvailableSortColumn.NAME) {
            compareFn = function (a, b) { return (a.building < b.building ? 1 : -1) * negate; };
        }
        if (currentSortColumn === ResultTableSort_1.AvailableSortColumn.SALE_PRICE) {
            compareFn = function (a, b) { return (a.salePrice < b.salePrice ? 1 : -1) * negate; };
        }
        if (currentSortColumn === ResultTableSort_1.AvailableSortColumn.LEASE_PRICE) {
            compareFn = function (a, b) { return (a.leasePrice < b.leasePrice ? 1 : -1) * negate; };
        }
        if (currentSortColumn === ResultTableSort_1.AvailableSortColumn.NET_SIZE) {
            compareFn = function (a, b) { return (a.sizeSaleable < b.sizeSaleable ? 1 : -1) * negate; };
        }
        if (currentSortColumn === ResultTableSort_1.AvailableSortColumn.GROSS_SIZE) {
            compareFn = function (a, b) { return (a.sizeGross < b.sizeGross ? 1 : -1) * negate; };
        }
        if (currentSortColumn === ResultTableSort_1.AvailableSortColumn.BED) {
            compareFn = function (a, b) {
                var bedFieldsA = a.amenities.filter(function (it) { return it.key === 'bed'; });
                var bedFieldsB = b.amenities.filter(function (it) { return it.key === 'bed'; });
                var bedsA = bedFieldsA.length ? bedFieldsA[0].value : -1;
                var bedsB = bedFieldsB.length ? bedFieldsB[0].value : -1;
                return (bedsA < bedsB ? 1 : -1) * negate;
            };
        }
        if (currentSortColumn === ResultTableSort_1.AvailableSortColumn.BATH) {
            compareFn = function (a, b) {
                var bathFieldsA = a.amenities.filter(function (it) { return it.key === 'bath'; });
                var bathFieldsB = b.amenities.filter(function (it) { return it.key === 'bath'; });
                var bathsA = bathFieldsA.length ? bathFieldsA[0].value : -1;
                var bathsB = bathFieldsB.length ? bathFieldsB[0].value : -1;
                return (bathsA < bathsB ? 1 : -1) * negate;
            };
        }
        if (currentSortColumn === ResultTableSort_1.AvailableSortColumn.UPDATE) {
            compareFn = function (a, b) { return (a.lastUpdated < b.lastUpdated ? 1 : -1) * negate; };
        }
        setProperties([].concat(props.properties.sort(compareFn)));
    }, [currentSortColumn, currentSortOrder, props.properties]);
    React.useEffect(function () {
        setProperties(props.properties);
    }, [props.properties]);
    React.useEffect(function () {
        if (props.type === SfilterTypeGroup_1.ListingPurposeType.Sale && currentSortColumn === ResultTableSort_1.AvailableSortColumn.LEASE_PRICE) {
            setCurrentSortColumn(ResultTableSort_1.AvailableSortColumn.SALE_PRICE);
        }
        if (props.type === SfilterTypeGroup_1.ListingPurposeType.Rent && currentSortColumn === ResultTableSort_1.AvailableSortColumn.SALE_PRICE) {
            setCurrentSortColumn(ResultTableSort_1.AvailableSortColumn.LEASE_PRICE);
        }
    }, [props.type]);
    return (React.createElement(ResultTable_1.default, __assign({}, props, { properties: props.limit >= 0 ? properties.slice(0, props.limit) : properties, currentSortColumn: currentSortColumn, currentSortOrder: currentSortOrder, onSortClick: onSortClick })));
};
exports.default = resultTableSortable;
